import React from 'react';
import PropTypes from 'prop-types';
import * as Ui from './AnimatedGradientBorder.styles';

const AnimatedGradientBorder = ({
  speed = 4,
  borderWidth = 1,
  blur = 10,
  borderRadius = 0,
  colors = [],
  backgroundColor = '#ffffff',
  disabled = false,
  children,
}) => (
  <Ui.Container
    $speed={speed}
    $borderWidth={borderWidth}
    $blur={blur}
    $borderRadius={borderRadius}
    $colors={colors.length > 1 ? [...colors, colors[0]] : colors}
    $disabled={disabled}
  >
    <Ui.Background $backgroundColor={backgroundColor} $borderRadius={borderRadius}>
      {children}
    </Ui.Background>
  </Ui.Container>
);

AnimatedGradientBorder.propTypes = {
  speed: PropTypes.number,
  borderWidth: PropTypes.number,
  blur: PropTypes.number,
  borderRadius: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.string),
  backgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default AnimatedGradientBorder;
